module.exports = __webpack_public_path__ + "static/media/beneficios.b9cdf0fb.svg";